// extracted by mini-css-extract-plugin
export default {"list":"MyCourse_list__JIn5T","myCourse":"MyCourse_myCourse__h0X7A"};